import { render, staticRenderFns } from "./OrderChangeLogDialog.vue?vue&type=template&id=6c3a6860&scoped=true"
import script from "./OrderChangeLogDialog.vue?vue&type=script&lang=js"
export * from "./OrderChangeLogDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderChangeLogDialog.vue?vue&type=style&index=0&id=6c3a6860&prod&lang=scss&scoped=true"
import style1 from "./OrderChangeLogDialog.vue?vue&type=style&index=1&id=6c3a6860&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3a6860",
  null
  
)

export default component.exports